import { requestFromServer, basePath } from './api-client';

const LoadingOrderClient = {
	searchLoadingOrder: async (loadingOrderNumber) => {
		return requestFromServer(`v1/Loading_Orders/findLoadingOrder/${loadingOrderNumber}`);
	},
	clear: async (id, reason) => {
		return requestFromServer(`v1/Loading_Orders/resetLoadingOrder/${id}`, "POST", { reason });
	},
	resetOCDocument: async (ocNumber) => {
		return requestFromServer(`v1/Loading_Orders/resetLoadingOrderDocument/${ocNumber}`, "DELETE");
	},
	importLoadingOrderDocumentURL: (loadingOrderNumber) => {
		return `${basePath}/api/v1/Loading_Orders/importOCFile/${loadingOrderNumber}`;
	},
};

export default LoadingOrderClient;
